import { Map } from 'immutable';

import { store } from 'store/configureStore';

import * as a from '../actions';

export class DialogService {
  constructor(reduxStore) {
    this.store = reduxStore;
    this.resolves = new Map();
  }

  push(dialog) {
    const { resolve, action } = dialog;

    const { id } = action.payload;

    this.resolves = this.resolves.set(id, resolve);

    this.store.dispatch(action);
  }

  resolve(id, value) {
    const resolve = this.resolves.get(id);

    this.store.dispatch(a.resolveDialog(id, value));

    if (resolve) {
      this.resolves = this.resolves.delete(id);
      resolve(value);
    }
  }
}

export default new DialogService(store);



// WEBPACK FOOTER //
// ./src/common/components/dialog/services/DialogService.js